import React from "react";
import "./contact.css";
const Contact = () => {
  return (
    <div className="myContact">
      <h1 style={{ textAlign: "center" }}>Contact Information</h1>
      <div className="contactMe">
        <h2>Berhane Beyene</h2>
        <h3>Chicago, IL</h3>
        <h3>
          Phone Number:{" "}
          <span>
            <a href="tel:708-427-2105">(708)427-2105</a>
          </span>
        </h3>
        <h3>
          Email:
          <a href="mailto:monoxica2004@yahoo.com">monoxica2004@yahoo.com</a>
        </h3>
      </div>
    </div>
  );
};

export default Contact;
